<template>
  <section>
    <div class="row my-4">
      <div class="col-12">
        <template v-if="reviews && reviews.length > 0">
          <div class="customer-review-card" v-for="review in reviews" :key="review.id">
            <div>
              <div class="customer-photo-section">
                <img v-lazy="review.customer_picture"
                    alt="customer picture"
                    class="rounded-circle img-fluid img-reviewer p-0">
              </div>
              <div class="customer-review-body">
                <div class="reply-name">{{ review.customer_name | firstName }}</div>
                <p>
                  <span v-html="$options.filters.ratingStar(review.rating)"></span>
                  <span class="text-secondary">{{ review.create_date  | prettyOnlyDate }}</span>
                </p>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="text-long mt-3" v-if="review.comment">
              {{ review.comment }}
            </div>
            <div class="text-right mt-3">
              <div>
                <div class="professional-picture-box">
                  {{ review.professional_name | firstName }}
                  <img v-lazy="review.professional_picture"
                       alt="professional picture c"
                       width="48"
                       class="rounded-circle img-fluid p-0 ml-2">
                    <img src="/static/img/ic_badge_excellent.png"
                         class="badge-excellent"
                         width="22"
                         v-b-popover.hover.top="$i18n.t('message.professional.excellent_provider_detail', {name: firstName(review.professional_name)})"
                         :title="$i18n.t('message.professional.excellent_provider_title')"
                         v-if="review.is_excellent === 1">
                </div>

              </div>
            </div>
            <hr>
          </div>
          <div class="text-center">
            <a href=""
                class="btn btn-outline-info"
                :disabled="isFetching"
                @click.prevent="fetchReviews"
                v-if="isMore">
              {{ $t(isLoadMore) }}
            </a>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'

  export default {
    data () {
      return {
        reviews: [],
        isMore: true,
        isFetching: false,
        queryData: {
          page: 0,
          limit: 10
        }
      }
    },
    computed: {
      isLoadMore () {
        return this.isFetching ? 'message.button.loading' : 'message.button.load_more_reviews'
      }
    },
    methods: {
      async fetchReviews () {
        this.queryData.page++
        let { data } = await axios.get('professionals/recent-reviews', {
          params: this.queryData
        })
        if (!data.error) {
          this.reviews.push(...data.reviews)
          if (!this.reviews.length) {
            this.isMore = false
          }
        } else {
          this.isMore = false
        }
      },
      firstName (name) {
        return this.$options.filters.firstName(name)
      }
    },
    mounted () {
      this.queryData.page = -1
      this.fetchReviews()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/professional/ProfessionalRecentReviews.vue